import { createContext, useContext, useState } from 'react';

const ScheduleRulesetContext = createContext();

const initialState = {
  isOpenFormUpsert: false,
  selectedRuleset: {},
  errorMessage: null,
  errorProps: {},
  errorFields: {},
};

const initialFilterState = {
  page: 1,
  limit: 10,
  sort: '',
  search: '',
  brandId: '',
};

const ScheduleRulesetProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return <ScheduleRulesetContext.Provider value={{ updateState, ...state, updateFilterState, filterState }}>{children}</ScheduleRulesetContext.Provider>;
};

export const useScheduleRulesetState = () => {
  return useContext(ScheduleRulesetContext);
};

export default ScheduleRulesetProvider;
